var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-nologin"},[_c('div',{staticClass:"nologin-title"},[_vm._v("你与搜货只有一步之遥")]),_c('button',{staticClass:"login-btn",on:{"click":_vm.goRegister}},[_vm._v("登录/注册")])])}
var staticRenderFns = []

export { render, staticRenderFns }